import React, { useEffect, useState } from "react";
import Box from "react-raster";
import { Button, Heading, Icon} from "src/components";
import { Badge } from "src/components/badge";
import { Tooltip } from "src/components/tooltip";
import { FontSize, theme } from "src/config";

export const ButtonSection = () => {
  const [buttonsLoading, setButtonsLoading] = useState(false);

  useEffect(() => {
    if (buttonsLoading) {
      setTimeout(() => setButtonsLoading(false), 2000);
    }
  }, [buttonsLoading]);

  return (
    <Box>
      <Box gridRowGap={theme.layout.gutterSmall} colspan={12}>
      <Heading weight="normal" type="h3" color="black" text="Cards">Buttons</Heading>
        <hr />
      </Box>

      <Box
        gridRowGap={theme.layout.gutterSmall}
        colspan={10}
        justifyContent="flex-start"
      >
        {["large", "default", "small"].map((s: FontSize) => (
          <Box cols={3} key={s}>
            <Button
              key={s}
              isLoading={buttonsLoading}
              size={s}
              variant="primary"
              onClick={() => setButtonsLoading(!buttonsLoading)}
            >
              Primary
            </Button>
          </Box>
        ))}
        <Box
          gridRowGap={theme.layout.gutterSmall}
          colspan={12}
          justifyContent="space-between"
        >
          {["large", "default", "small"].map((s: FontSize) => (
          <Box cols={3} key={s}>
            <Button
              key={s}
              isLoading={buttonsLoading}
              size={s}
              variant="alert"
              onClick={() => setButtonsLoading(!buttonsLoading)}
            >
              Alert
            </Button>
          </Box>
        ))}
        </Box>
  
        <Box
          gridRowGap={theme.layout.gutterSmall}
          colspan={12}
          justifyContent="space-between"
        >
          {["large", "default", "small"].map((s: FontSize) => (
            <Box cols={3} key={s}>
              <Button
                key={s}
                isLoading={buttonsLoading}
                size={s}
                variant="outlined"
                onClick={() => setButtonsLoading(!buttonsLoading)}
              >
                Outlined
              </Button>
            </Box>
          ))}
        </Box>
        <Box
          gridRowGap={theme.layout.gutterSmall}
          colspan={6}
          justifyContent="space-between"
        >
          <Box cols={2}>
            <Button
              disabled
              isLoading={buttonsLoading}
              size="default"
              onClick={() => setButtonsLoading(!buttonsLoading)}
            >
              Disabled
            </Button>
          </Box>
          <Box cols={2}>
            <Button
              variant="primary"
              isLoading={buttonsLoading}
              size="default"
              iconId="arrowBack"
              iconPosition="right"
              onClick={() => setButtonsLoading(!buttonsLoading)}
            >
              Primary
            </Button>
          </Box>
          <Box cols={2}>
            <Button
              variant="primary"
              isLoading={buttonsLoading}
              size="default"
              iconPosition="left"
              iconId="arrowForward"
              onClick={() => setButtonsLoading(!buttonsLoading)}
            >
              Primary
            </Button>
          </Box>
        </Box>
        <Box>
          <hr />
        </Box>
        <hr />
        <Box display="flex" flexDirection="column">
        <Heading weight="normal" type="h3" color="black" text="Cards">Icon buttons</Heading>
          <Box display="flex" flexDirection="row">
            <Tooltip content="Size small">
              <Button variant="icon">
                <Icon iconId="calendar" cursor="pointer" size="small" />
              </Button>
            </Tooltip>
            <br />
            <Tooltip content="Size medium">
              <Button variant="icon">
                <Icon iconId="calendar" cursor="pointer" size="medium" />
              </Button>
            </Tooltip>
            <br />
            <Tooltip content="Size large">
              <Button variant="icon">
            <Badge content="!">
            <Icon iconId="calendar" cursor="pointer" size="large" />
              </Badge>
              </Button>
            </Tooltip>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
